import { render } from "./Cdn.vue?vue&type=template&id=f06b512e"
import script from "./Cdn.vue?vue&type=script&lang=js"
export * from "./Cdn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__